module.exports = __webpack_public_path__ + "media/images/front/brands/creations/creations_header_2_m-8cee1a5ec45822ccb084598b9c861ffb.webp";